import { t } from 'i18next';

export function getPackageTypeDisplay(aPackage) {
  return aPackage.type === 'Plan' ? t('sharedComponents.plan') : t('sharedComponents.addon');
}
